import { Component, OnInit } from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../shared/auth/auth.service";
import {NgxSpinnerService} from "ngx-spinner";
import Me from "../../../helpers/me";
import {SocialAuthService} from "angularx-social-login";
import App from "../../../helpers/app";
import Api from "../../../helpers/api";
import {take} from "rxjs/operators";
import Swal from "sweetalert2";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import * as CryptoJS from 'crypto-js'
import { DomSanitizer } from '@angular/platform-browser';

declare var Iugu: any;
@Component({
  selector: 'app-infos',
  templateUrl: './infos.component.html',
  styleUrls: ['./infos.component.scss']
})
export class InfosComponent implements OnInit {
  apiCall = this.api.new().silent();
  acceptPromoMessages = null;
  acceptPromoMessagesCustomers = null;
  user = null;
  formUpdateSenha = {
    password: null,
    newPassword: null,
    confirmPassword: null,
  }
  selectedColor = null
  
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });

  activeId = 1

  urlToPlay = null
  safeURL = null
  constructor(private modal: NgbModal,
              private router: Router,
              private authService: AuthService,
              private spinner: NgxSpinnerService,
              private route: ActivatedRoute,
              private me: Me,
              private socialAuthService: SocialAuthService,
              private app: App,
              private _sanitizer: DomSanitizer,
              private api: Api) {

                this.me.get().pipe(take(1)).toPromise().then((user)=>{
                  this.user = user
                  let jUser = null
                  jUser = JSON.parse(JSON.stringify(this.user))
           
                  if(jUser){
                   this.acceptPromoMessages = jUser.acceptPromoMessages
                   this.acceptPromoMessagesCustomers = jUser.acceptPromoMessagesCustomers
                  }
                  
               })
               
    this.route.params.subscribe((params)=>{
      if(params['destId']) {
        this.activeId = +params['destId']
      }
    })
  }



  async ngOnInit() {
    await this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    const user = await this.me.get(false).pipe(take(1)).toPromise()
    this.user = this.formatTelUser(user)
    const dataColor = await this.apiCall.get('me/userparams/appBaseColor').pipe(take(1)).toPromise()
    this.selectedColor = dataColor.return? dataColor.return.value : "#2ebfca"
    this.phoneForm.patchValue({
      phone: this.user.phone
    });
    await this.spinner.hide()
  }
  async verifyFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      let retorno = ''
      reader.onload =  (function(theFile) {
        var image = new Image();
        image.src = theFile.target.result.toString();
        image.onload = function() {
          // access image size here
          if(image.width!=414 || image.height!=150){
            resolve('a proporção da imagem está invalida! É obrigatório utilizar a proporção de 414px x 150px')
          }else{
            resolve(null)
          }
        };
      });
    });
  }
  async fileToBase64(file) {
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  async changeBanner(){
    const self = this
    const { value: file } = await Swal.fire({
      title: 'Novo Banner',
      input: 'file',
      text: 'É obrigatório utilizar a proporção de 414px x 150px',
      showCancelButton: true,
      cancelButtonText: `Cancelar`,
      confirmButtonText: `Salvar`,
      inputAttributes: {
        'accept': 'image/*',
        'aria-label': 'Faça upload de sua foto de perfil. Sugerimos proporção de 414px x 150px.'
      },
      inputValidator: async (value) => {
        if (!value) {
          return 'Você precisa escolher um banner!'
        }
        // @ts-ignore
        let file:File = value

        if(file.size>1000000){
          return 'São permitidos banners de até 1MB!'
        }

        const retorno = await self.verifyFile(file)
        if(retorno){
          return retorno.toString()
        }
      }
    })

    if (file) {
      const base64 = await self.fileToBase64(file)
      var reader = new FileReader(); //define a Reader
      reader.onload = async function (f)  {
        var file_result = this.result;
        var file_wordArr = CryptoJS.lib.WordArray.create(file_result);
        var sha1_hash = CryptoJS.SHA1(file_wordArr);
        let sha1 = sha1_hash.toString()
        await self.spinner.show(undefined,
          {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });
        const dataUrl = await self.apiCall.get('blackbaze/urltoupload').pipe(take(1)).toPromise()
        if(!dataUrl.return){
          await self.spinner.hide()
          return
        }
        if(dataUrl.return && dataUrl.return.authorizationToken && dataUrl.return.uploadUrl && dataUrl.return.uniqid){
          var optionsB2 = { headers: {  'Authorization': dataUrl.return.authorizationToken, 'Content-Type': file.type, 'X-Bz-File-Name': dataUrl.return.uniqid.toString()+'.'+file.name.split('?')[0].split('.').pop(), 'X-Bz-Content-Sha1' : sha1 } };
          const returnedUpload = await self.api.http.post(dataUrl.return.uploadUrl, file, optionsB2).toPromise()
          await self.spinner.hide()
          if(returnedUpload){
            self.user.banner = 'https://files.wecodde.com/file/wecodde/'+JSON.parse(JSON.stringify(returnedUpload)).fileName
            self.updateUser()
            await self.apiCall.put('users/objectives/update/5').pipe(take(1)).toPromise()
          }
        }
      };
      reader.readAsArrayBuffer(file);
    }
  }
  
  async verifyFileCapaPlataforma(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      let retorno = ''
      reader.onload =  (function(theFile) {
        var image = new Image();
        image.src = theFile.target.result.toString();
        image.onload = function() {
          // access image size here
          if(image.width!=1980 || image.height!=480){
            resolve('A proporção da imagem está invalida! É obrigatório utilizar a proporção de 1980px x 480px')
          }else{
            resolve(null)
          }
        };
      });
    });
  }
  async changeCapaPlataforma(){
    const self = this
    const { value: file } = await Swal.fire({
      title: 'Nova Capa',
      html:
        '<p>Antes de fazer o upload do banner veja algumas informações importantes:</p>' +
        '<ul style="text-align: left">' +
        '<li style="margin-bottom: 5px">1 - A resolução deve ser exatamente 1980px x 480px</li>' +
        '<li style="margin-bottom: 5px">2 - A extensão do banner deve ser JPG ou PNG</li>' +
        '<li style="margin-bottom: 5px">3 - Para reduzir o tamanho do seu banner, clique nesse link <a target="_blank"  href="https://tinypng.com/">tinypng.com</a></li>' +
        '<li style="margin-bottom: 5px">4 - Está sem criatividade? Veja nossos modelos <a target="_blank"  href="https://opersonaldigital.com.br/modelos-de-banner">aqui</a></li>' +
        '</ul>',
      input: 'file',
      showCancelButton: true,
      cancelButtonText: `Cancelar`,
      confirmButtonText: `Salvar`,
      inputAttributes: {
        'accept': 'image/*',
        'aria-label': 'Faça upload da sua foto de Capa. Sugerimos proporção de 1980px x 480px.'
      },
      inputValidator: async (value) => {
        if (!value) {
          return 'Você precisa escolher uma capa!'
        }
        // @ts-ignore
        let file:File = value

        if(file.size>1000000){
          return 'São permitidos capas de até 1MB!'
        }

        const retorno = await self.verifyFileCapaPlataforma(file)
        if(retorno){
          return retorno.toString()
        }
      }
    })

    console.log("file",file)

    if (file) {
      const base64 = await self.fileToBase64(file)
      var reader = new FileReader(); //define a Reader
      reader.onload = async function (f)  {
        var file_result = this.result;
        var file_wordArr = CryptoJS.lib.WordArray.create(file_result);
        var sha1_hash = CryptoJS.SHA1(file_wordArr);
        let sha1 = sha1_hash.toString()
        await self.spinner.show(undefined,
          {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });
        const dataUrl = await self.apiCall.get('blackbaze/urltoupload').pipe(take(1)).toPromise()
        if(!dataUrl.return){
          await self.spinner.hide()
          return
        }
        if(dataUrl.return && dataUrl.return.authorizationToken && dataUrl.return.uploadUrl && dataUrl.return.uniqid){
          var optionsB2 = { headers: {  'Authorization': dataUrl.return.authorizationToken, 'Content-Type': file.type, 'X-Bz-File-Name': dataUrl.return.uniqid.toString()+'.'+file.name.split('?')[0].split('.').pop(), 'X-Bz-Content-Sha1' : sha1 } };
          const returnedUpload = await self.api.http.post(dataUrl.return.uploadUrl, file, optionsB2).toPromise()
          await self.spinner.hide()
          if(returnedUpload){
            self.user.capaPlataforma = 'https://files.wecodde.com/file/wecodde/'+JSON.parse(JSON.stringify(returnedUpload)).fileName
            self.updateUser()
            await self.apiCall.put('users/objectives/update/4').pipe(take(1)).toPromise()
          }
        }
      };
      reader.readAsArrayBuffer(file);
    }
  }

  async changePhoto(){
    const self = this
    const { value: file } = await Swal.fire({
      title: 'Nova Foto de Perfil',
      input: 'file',
      text: 'Sugerimos proporção de 140px x 140px',
      showCancelButton: true,
      cancelButtonText: `Cancelar`,
      confirmButtonText: `Salvar`,
      inputAttributes: {
        'accept': 'image/*',
        'aria-label': 'Faça upload de sua foto de perfil. Sugerimos proporção de 140 x 140.',
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Você precisa escolher uma nova foto!'
        }
      }
    })

    
    //@ts-ignore
    console.log("file",file)

    if (file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async  () => {
        let arquivo = reader.result.toString()
        self.spinner.show(undefined,
          {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });
        self.apiCall.put('seller/me/picture', {picture: arquivo}).subscribe(async data => {
          self.me.refresh().subscribe(async u => {
            self.user = u
            self.spinner.hide()
            if(data.success){
              this.user = this.formatTelUser(this.user)

              await this.app.alert('Tudo certo!',  'Sua foto de perfil foi atualizada com sucesso', 'success')
            }else{
              await this.app.alert('Ops :(', data.message, 'error')
            }
            location.reload()
          });

        });
      }
      reader.onabort = () => {
      };
      reader.onerror = () => {
      }
    }
  }

  async updateUser(){
    const self = this
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

    if(this.phoneForm && this.phoneForm.controls['phone'] && this.phoneForm.controls['phone'].value && this.phoneForm.controls['phone'].value.e164Number){
      this.user.phone = this.phoneForm.controls['phone'].value.e164Number
    }

    let userToSend = this.user
    if(userToSend.phone && !userToSend.phone.toString().startsWith('+')){
      userToSend.phone = '+'+userToSend.phone
    }
    this.me.update(userToSend).then(async data=>{
      this.user = this.formatTelUser(this.user)
      await self.spinner.hide()
      await self.app.alert('Tudo certo!',  'Seu usuário foi atualizado com sucesso', 'success')
      this.ngOnInit()
    }).catch(async error => {
      await self.spinner.hide()
      await this.app.alert('Ops :(', 'Ocorreu algum erro ao atualizar seus dados', 'error')
    })

  }

  formatTelUser(user){
    if(user){
      if(user.phone && !user.phone.toString().startsWith('+')){
        user.phone = '+'+user.phone
      }
    }
    return user

  }
  async updatePassword(){
    const self = this
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    self.me.updatePassword({password: this.formUpdateSenha.password, newPassword: this.formUpdateSenha.newPassword, confirmPassword: this.formUpdateSenha.confirmPassword}).pipe(take(1)).toPromise().then(async data=>{
      this.user = this.formatTelUser(this.user)

      self.spinner.hide()
      await this.app.alert('Tudo certo!',  'Sua senha foi atualizada com sucesso', 'success')
    }).catch(async error => {
      await self.spinner.hide()
      await this.app.alert('Ops :(', error.message, 'error')
    })
  }

  updateAcceptPromoMessages(modal){
    const self = this
    console.log(this.acceptPromoMessages)
  
    Swal.fire({
      title: "Tem certeza?",
      text: this.acceptPromoMessages ? 'Deseja ativar as mensagens promocionais?' : 'Deseja desativar as mensagens promocionais?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
       confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar"
  }).then((result) => {
    if (result.isConfirmed) {
  
      self.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
  
        self.apiCall.put('seller/me/updateacceptpromomessages', {acceptPromoMessages : this.acceptPromoMessages}).subscribe(async data => {
          if(data.success){
            self.user = await this.me.get(false).pipe(take(1)).toPromise()
            this.spinner.hide()
            await this.app.alert('Tudo certo!',  'Preferência da mensagem promocional alterada com sucesso', 'success')
            modal.close('Close click')
            this.ngOnInit()
          }else{
            await this.app.alert('Ops :(', data.message, 'error')
          }
        });
     } else if (result.isDismissed) {
      this.acceptPromoMessages = !this.acceptPromoMessages
    }
  })
  }

  updateAcceptPromoMessagesCustomers(modal){
    const self = this
    console.log(this.acceptPromoMessagesCustomers)
  
    Swal.fire({
      title: "Tem certeza?",
      text: this.acceptPromoMessagesCustomers ? 'Deseja ativar as mensagens promocionais para seus alunos?' : 'Deseja desativar as mensagens promocionais para seus alunos?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
       confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar"
  }).then((result) => {
    if (result.isConfirmed) {
  
      self.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
  
        self.apiCall.put('seller/me/updateacceptpromomessagescustomers', {acceptPromoMessagesCustomers : this.acceptPromoMessagesCustomers}).subscribe(async data => {
          if(data.success){
            self.user = await this.me.get(false).pipe(take(1)).toPromise()
            this.spinner.hide()
            await this.app.alert('Tudo certo!',  'Preferência da mensagem promocional alterada com sucesso', 'success')
            modal.close('Close click')
            this.ngOnInit()
          }else{
            await this.app.alert('Ops :(', data.message, 'error')
          }
        });
     } else if (result.isDismissed) {
      this.acceptPromoMessagesCustomers = !this.acceptPromoMessagesCustomers
    }
  })
  }

  OpenModalXl(content) {
    this.modal.open(content, { centered: true, size: "xl" });
  }

  viewMidia(urlToPlay, content){
    this.urlToPlay = urlToPlay
    if(urlToPlay.startsWith('https://www.youtube.com/watch?')){
      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(urlToPlay.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/'));
  
    }else if(urlToPlay.startsWith('http://www.youtube.com/watch?')){
      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(urlToPlay.replace('http://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/'));
    }
    this.modal.open(content, { centered: true , size:'lg'});
  }

  saveColor() {
    const self = this
    const value = self.selectedColor
    console.log("color", value)

    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });


    self.apiCall.put('me/userparams/appBaseColor', {value}).subscribe(async data => {
      if(data.success){
        this.spinner.hide()
        await this.app.alert('Tudo certo!',  'Preferência salva com sucesso!', 'success')
        this.ngOnInit()
      }else{
        this.spinner.hide()

        await this.app.alert('Ops :(', data.message, 'error')
      }
    });
  
  }

  resetAppColor() {
    const self = this

    self.app.confirm('Tem certeza?', 'Você realmente deseja deletar a cor personalizada?').then(d=>{
      if(d){

    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });


    self.apiCall.delete('me/userparams/appBaseColor').subscribe(async data => {
      if(data.success){
        this.spinner.hide()
        await this.app.alert('Tudo certo!',  'Preferência de cor resetada com sucesso!', 'success')
        this.ngOnInit()
      }else{
        await this.app.alert('Ops :(', data.message, 'error')
      }
    });

  }
})
  
  }
}




